export function getMaxTimestamp(this_p) {
  let maxTimestamp = 0;

  // Map dataSource to the corresponding tiles array
  let tilesMap = {
    nw: this_p.tiles,
    hr_de: this_p.tilesHRDE,
    hr_fr: this_p.tilesHRFR,
    hr_nl: this_p.tilesHRNL,
    hr_bi: this_p.tilesHRUK,
    hr_be: this_p.tilesHRBE,
    hr_sc: this_p.tilesHRSC,
    hr_ip: this_p.tilesHRES,
    opera: this_p.tilesOpera,
    foreca: this_p.tilesForeca,
    foreca_global: this_p.tilesForecaGlobal,
  };

  let tiles = tilesMap[this_p.dataSource];

  // Check if tiles are defined and not empty
  if (!tiles || tiles.length === 0 || !tiles[0] || tiles[0].length === 0) {
    return maxTimestamp;
  }

  let timeLength = tiles.length;
  let zoomLength = tiles[0].length;

  for (let iT = 0; iT < timeLength; iT++) {
    for (let zL = 0; zL < zoomLength; zL++) {
      const tile = tiles[iT][zL];
      if (tile != null) {
        for (let [, value] of tile) {
          let ts = getTS(value.forecastTime);
          if (ts > maxTimestamp) {
            maxTimestamp = ts;
          }
        }
      }
    }
  }

  return maxTimestamp;
}

export function getTS(timeStr) {
  const unixTimestamp = Date.parse(timeStr);
  return isNaN(unixTimestamp) ? 0 : unixTimestamp;
}
